import * as React from 'react';
import { connect } from 'react-redux';
import * as Moment from 'moment';
import { CalendarAppState } from '../classes/redux-states';
import { Dispatch } from 'redux';
import { IAAPDEvent } from '../classes/event';
import { ActionType, setContent } from '../redux/actions/actions';
import GridItemComponent from './calendar-grid-event';

export interface ExternalProps {
    events: IAAPDEvent[];
    dayOfMonth: number;
}

export interface StateToProps {
    selectedDate: Moment.Moment
}

interface DispatchToProps {
    setContent: (content: IAAPDEvent) => any;
}

interface GridDayState {
}

type GridDayProps = ExternalProps & StateToProps & DispatchToProps;

export class GridDayComponent extends React.Component<GridDayProps, GridDayState> {
    constructor(props: GridDayProps) {
        super(props);
    }

    private get _getAriaLabel(): string {
        return `${this.props.selectedDate.clone().startOf('month').add(this.props.dayOfMonth, 'days').format("dddd")}, ${this.props.selectedDate.format("MMMM")} ${this.props.dayOfMonth + 1}: ${this.props.events.length} events`;
    }

    render() {
        if (this.props.events.length == 0) {
            return (
                <li className="calendar-grid-day no-events" aria-label={this._getAriaLabel}>
                    <span className="calendar-grid-date">
                        {
                            this.props.dayOfMonth + 1
                        }
                    </span>
                </li>
            )
        } else {
            return (
                <li className="calendar-grid-day" aria-label={this._getAriaLabel}>
                    <span className="calendar-grid-date">
                        {
                            this.props.dayOfMonth + 1
                        }
                    </span>
                    <div className="calendar-grid-day-inner">
                        <ul aria-label="List of Events" className="calendar-grid-events">
                            {
                                this.props.events.map((event, index) => <GridItemComponent key={index} event={event} />)
                            }
                        </ul>
                    </div>
                </li>
            )
        }
    }
}

function mapStateToProps(state: CalendarAppState) {
    return {
        selectedDate: state.calendarApiModel.selectedDate
    }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>, ownProps: ExternalProps): DispatchToProps {
    return {
        setContent: (content: IAAPDEvent) => dispatch(setContent(content))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GridDayComponent)




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-grid-day.tsx